export const routeProps = {
  path: '/payment_method/(validate|review|confirm|print)',
  exact: true,
};

export default (step = 'validate') => `/payment_method/${step}`;
